export const CREATE_GLOSSARY_CATEGORY_SUCCESS_GLOSSARY_CATEGORY_CREATED =
    'europa.glossary.CreateGlossaryCategory.GlossaryCategoryCreated';
export const CREATE_GLOSSARY_CATEGORY_FAILURE_GLOSSARY_CATEGORY_EXISTS =
    'europa.glossary.CreateGlossaryCategory.GlossaryCategoryExists';
export const CREATE_GLOSSARY_CATEGORY_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.CreateGlossaryCategory.GlossaryNotModifiable';
export const CREATE_GLOSSARY_CATEGORY_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.CreateGlossaryCategory.UnexpectedFailure';
export const CREATE_GLOSSARY_TERM_FAILURE_GLOSSARY_CATEGORY_NOT_FOUND =
    'europa.glossary.CreateGlossaryTerm.GlossaryCategoryNotFound';
export const CREATE_GLOSSARY_TERM_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.CreateGlossaryTerm.GlossaryNotModifiable';
export const CREATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_CREATED =
    'europa.glossary.CreateGlossaryTerm.GlossaryTermCreated';
export const CREATE_GLOSSARY_TERM_FAILURE_GLOSSARY_TERM_EXISTS =
    'europa.glossary.CreateGlossaryTerm.GlossaryTermExists';
export const CREATE_GLOSSARY_TERM_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.CreateGlossaryTerm.UnexpectedFailure';
export const DELETE_GLOSSARY_CATEGORY_SUCCESS_GLOSSARY_CATEGORY_DELETED =
    'europa.glossary.DeleteGlossaryCategory.GlossaryCategoryDeleted';
export const DELETE_GLOSSARY_CATEGORY_FAILURE_GLOSSARY_CATEGORY_NOT_FOUND =
    'europa.glossary.DeleteGlossaryCategory.GlossaryCategoryNotFound';
export const DELETE_GLOSSARY_CATEGORY_FAILURE_GLOSSARY_CATEGORY_STILL_CONTAINS_TERMS =
    'europa.glossary.DeleteGlossaryCategory.GlossaryCategoryStillContainsTerms';
export const DELETE_GLOSSARY_CATEGORY_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.DeleteGlossaryCategory.GlossaryNotModifiable';
export const DELETE_GLOSSARY_CATEGORY_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.DeleteGlossaryCategory.UnexpectedFailure';
export const DELETE_GLOSSARY_TERM_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.DeleteGlossaryTerm.GlossaryNotModifiable';
export const DELETE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_DELETED =
    'europa.glossary.DeleteGlossaryTerm.GlossaryTermDeleted';
export const DELETE_GLOSSARY_TERM_FAILURE_GLOSSARY_TERM_NOT_FOUND =
    'europa.glossary.DeleteGlossaryTerm.GlossaryTermNotFound';
export const DELETE_GLOSSARY_TERM_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.DeleteGlossaryTerm.UnexpectedFailure';
export const GET_GLOSSARY_SUCCESS_GLOSSARY_DTO = 'europa.glossary.GetGlossary.GlossaryDto';
export const GET_GLOSSARY_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.GetGlossary.UnexpectedFailure';
export const UPDATE_GLOSSARY_CATEGORY_NAME_FAILURE_GLOSSARY_CATEGORY_EXISTS =
    'europa.glossary.UpdateGlossaryCategoryName.GlossaryCategoryExists';
export const UPDATE_GLOSSARY_CATEGORY_NAME_FAILURE_GLOSSARY_CATEGORY_NAME_UP_TO_DATE =
    'europa.glossary.UpdateGlossaryCategoryName.GlossaryCategoryNameUpToDate';
export const UPDATE_GLOSSARY_CATEGORY_NAME_SUCCESS_GLOSSARY_CATEGORY_NAME_UPDATED =
    'europa.glossary.UpdateGlossaryCategoryName.GlossaryCategoryNameUpdated';
export const UPDATE_GLOSSARY_CATEGORY_NAME_FAILURE_GLOSSARY_CATEGORY_NOT_FOUND =
    'europa.glossary.UpdateGlossaryCategoryName.GlossaryCategoryNotFound';
export const UPDATE_GLOSSARY_CATEGORY_NAME_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.UpdateGlossaryCategoryName.GlossaryNotModifiable';
export const UPDATE_GLOSSARY_CATEGORY_NAME_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.UpdateGlossaryCategoryName.UnexpectedFailure';
export const UPDATE_GLOSSARY_TERM_FAILURE_GLOSSARY_CATEGORY_NOT_FOUND =
    'europa.glossary.UpdateGlossaryTerm.GlossaryCategoryNotFound';
export const UPDATE_GLOSSARY_TERM_FAILURE_GLOSSARY_NOT_MODIFIABLE =
    'europa.glossary.UpdateGlossaryTerm.GlossaryNotModifiable';
export const UPDATE_GLOSSARY_TERM_FAILURE_GLOSSARY_TERM_NOT_FOUND =
    'europa.glossary.UpdateGlossaryTerm.GlossaryTermNotFound';
export const UPDATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_UPDATED =
    'europa.glossary.UpdateGlossaryTerm.GlossaryTermUpdated';
export const UPDATE_GLOSSARY_TERM_FAILURE_UNEXPECTED_FAILURE =
    'europa.glossary.UpdateGlossaryTerm.UnexpectedFailure';
